import { useDeleteUserMutation } from '../hooks'
import { useUsersStore } from '../store/usersStore'
import type { ApiError } from '@/types/api'
import { Modal } from '@/components/custom/modal'
import LoadingButton from '@/components/custom/loading-button'
import { notifyRequestError } from '@/utils/notifyRequestError'

export function DeleteUser({
  id,
  trigger,
  open,
  onClose,
}: {
  id: string | null
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}) {
  const { mutateAsync: deleteUserMutation, isPending } = useDeleteUserMutation()

  const users = useUsersStore((s) => s.users)
  const user = users.find((u) => u._id === id)

  const handleDeleteUser = async () => {
    if (!user) return

    try {
      await deleteUserMutation(user._id)
      onClose?.()
    } catch (error) {
      notifyRequestError(error as ApiError, 'Failed to delete user')
    }
  }

  return (
    <Modal open={open} onClose={onClose} trigger={trigger} title="Delete User">
      <div className="space-y-4">
        <p>
          Are you sure you want to delete user <strong>{user?.name}</strong>?
          <br />
          <span className="text-red-500 font-semibold">
            This action is permanent and cannot be undone.
          </span>
        </p>
        <LoadingButton
          type="submit"
          className="w-full"
          isLoading={isPending}
          disabled={isPending}
          onClick={handleDeleteUser}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </LoadingButton>
      </div>
    </Modal>
  )
}
